import { Plus } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useI18nContext } from '@/i18n/i18n-react';
import { cn } from '@/lib/utils';

interface AudienceCreateFilterEmptyStateProps {
  onAddFirstFilter: () => void;
  className?: string;
}

export function AudienceCreateFilterEmptyState({
  onAddFirstFilter,
  className,
}: AudienceCreateFilterEmptyStateProps) {
  const { LL } = useI18nContext();

  return (
    <div
      className={cn(
        'flex min-h-[40vh] min-w-0 flex-col items-center justify-center gap-4 px-4 text-center',
        className
      )}
    >
      <div className="mt-10 flex max-w-md flex-col gap-2 sm:mt-12">
        <h2 className="text-2xl font-medium tracking-tight sm:text-3xl">
          {LL.audiences.create.emptyState.title()}
        </h2>
        <p className="text-sm text-muted-foreground sm:text-base">
          {LL.audiences.create.emptyState.description()}
        </p>
      </div>
      <Button type="button" onClick={onAddFirstFilter}>
        <Plus className="size-4" />
        {LL.audiences.create.emptyState.addFirstFilter()}
      </Button>
    </div>
  );
}
